package team.platforma.multiplatform_material_extension.calendar.core.core_ui

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.scaleIn
import androidx.compose.animation.scaleOut
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.layout.wrapContentSize
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import team.platforma.multiplatform_material_extension.calendar.style.CalendarViewStyle

@Composable
internal fun CalendarBadge(
    value: Int,
    cellSize: Dp
) {
    val minBadgeSize = cellSize / 3
    Box(
        modifier = Modifier.fillMaxSize().padding(
            horizontal = CalendarViewStyle.dateStyle().cellPadding.horizontal,
            vertical = CalendarViewStyle.dateStyle().cellPadding.vertical
        ), contentAlignment = Alignment.TopEnd
    ) {
        AnimatedVisibility(
            visible = value > 0, enter = fadeIn() + scaleIn(), exit = fadeOut() + scaleOut()
        ) {
            Box(
                modifier = Modifier.wrapContentWidth().wrapContentSize().background(
                    color = CalendarViewStyle.badgeStyle().background,
                    shape = CalendarViewStyle.badgeStyle().shape
                ), contentAlignment = Alignment.Center
            ) {

                Box(
                    modifier = Modifier.widthIn(min = minBadgeSize).heightIn(min = minBadgeSize)
                        .padding(2.dp), contentAlignment = Alignment.Center
                ) {
                    Text(
                        text = when {
                            value > 99 -> "99+"
                            value == 0 -> ""
                            else -> value.toString()
                        },
                        color = CalendarViewStyle.badgeStyle().textColor,
                        style = TextStyle(
                            fontSize = (minBadgeSize.value * CalendarViewStyle.badgeStyle().fontSize).sp,
                            fontWeight = CalendarViewStyle.badgeStyle().fontWeight,
                            textAlign = TextAlign.Center,
                            lineHeight = TextUnit.Unspecified,
                            letterSpacing = 0.sp
                        ),
                        maxLines = 1
                    )
                }
            }
        }
    }
}